import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Container = styled(Stack)`
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #3169f6;
  padding: 16px;
`;

const Title = styled(Typography)`
  font-size: 22px;
  font-weight: 700;
  color: #0f1629;
`;

const InfoBox = styled(Stack)`
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const Dot = styled(Box)`
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;

const Label = styled(Box)`
  font-size: 14px;
  font-weight: 700;
  color: #6c7589;
`;

type Props = {
  low: number;
  high: number;
};

export const MapProgressHeader = ({ low, high }: Props) => (
  <Container direction="row">
    <Title>Map Knowledge Growth</Title>
    <Stack direction="row" spacing={3} visibility="hidden">
      <InfoBox>
        <Dot bgcolor="#B820FF" />
        <Label>Low ({low})</Label>
      </InfoBox>
      <InfoBox>
        <Dot bgcolor="#0AA6D1" />
        <Label>High ({high})</Label>
      </InfoBox>
    </Stack>
  </Container>
);
